// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".calloutLeg__table th[data-v-4aa9c4b2] {\n    text-align: left;\n    font-weight: 300\n}\n.calloutLeg__table td[data-v-4aa9c4b2] {\n    font-weight: 600\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
